"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMfwThemeProvider = exports.MfwThemeProvider = exports.MfwThemeContext = void 0;
var react_1 = __importStar(require("react"));
var createMfwMobTheme_1 = require("./createMfwMobTheme");
var createMfwWebTheme_1 = require("./createMfwWebTheme");
var defaultTheme_1 = require("./defaultTheme");
exports.MfwThemeContext = react_1.createContext({
    theme: defaultTheme_1.defaultProviderTheme,
    setThemeName: function (a) { },
    mfwMuiWebTheme: createMfwWebTheme_1.createMFWTheme(createMfwWebTheme_1.defaultSettings, defaultTheme_1.defaultTheme),
    mfwMobTheme: createMfwMobTheme_1.createMFWThemeMob(defaultTheme_1.defaultTheme),
    isLoading: true,
    updateTheme: function (colors) { },
});
exports.MfwThemeProvider = function (_a) {
    var children = _a.children, getThemeBy = _a.getThemeBy;
    var _b = react_1.useState(defaultTheme_1.defaultProviderTheme), themeObject = _b[0], setThemeObject = _b[1]; // theme that is returned
    var _c = react_1.useState("dark"), themeName = _c[0], setThemeName = _c[1]; //dark / light
    var _d = react_1.useState(createMfwWebTheme_1.createMFWTheme(createMfwWebTheme_1.defaultSettings, defaultTheme_1.defaultTheme)), mfwMuiWebTheme = _d[0], setMfwWebMuiTheme = _d[1]; //used for WEB
    var _e = react_1.useState(createMfwMobTheme_1.createMFWThemeMob(defaultTheme_1.defaultTheme)), mfwMobTheme = _e[0], setMfwMobTheme = _e[1]; //used for MOB
    var _f = react_1.useState(defaultTheme_1.defaultThemeObject), whiteLabelTheme = _f[0], setWhiteLabelTheme = _f[1]; // dark and light theme - full object
    var _g = react_1.useState(true), isLoading = _g[0], setIsLoading = _g[1];
    var setPlatformTheme = function (t) {
        setMfwMobTheme(createMfwMobTheme_1.createMFWThemeMob(t));
        setMfwWebMuiTheme(createMfwWebTheme_1.createMFWTheme(createMfwWebTheme_1.defaultSettings, t));
    };
    var getThemeFromDb = function (_, timeoutEnabled) { return __awaiter(void 0, void 0, void 0, function () {
        var fetchFromUrl, res, response, responseJson, e_1, _a, newCurrentTheme, newThemeObj;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!_) {
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    fetchFromUrl = _.functions_base_url + "/theme";
                    if (_.orgId) {
                        fetchFromUrl += "?orgId=" + _.orgId;
                    }
                    res = null;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 7]);
                    return [4 /*yield*/, fetch(fetchFromUrl, {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                            },
                        })];
                case 2:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    responseJson = (_b.sent());
                    if (!responseJson.data) {
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    res = responseJson.data;
                    return [3 /*break*/, 7];
                case 4:
                    e_1 = _b.sent();
                    _a = timeoutEnabled;
                    if (!_a) return [3 /*break*/, 6];
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(function () {
                            getThemeFromDb(_, false);
                            resolve(true);
                        }, 5000); })];
                case 5:
                    _a = (_b.sent());
                    _b.label = 6;
                case 6:
                    _a;
                    return [2 /*return*/];
                case 7:
                    newCurrentTheme = __assign({ type: themeName }, res.theme[themeName]);
                    newThemeObj = __assign(__assign({}, res), { theme: res.theme[themeName], isWhiteLabel: res.orgId === "5BeUsYXvwxckki8hpxLS" ? false : true });
                    setThemeObject(newThemeObj);
                    setWhiteLabelTheme(res);
                    setPlatformTheme(newCurrentTheme);
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    react_1.useEffect(function () {
        var newCurrentTheme = __assign({ type: themeName }, whiteLabelTheme.theme[themeName]);
        setPlatformTheme(newCurrentTheme);
    }, [themeName]);
    react_1.useEffect(function () {
        if (getThemeBy.functions_base_url !== "") {
            getThemeFromDb(getThemeBy, true);
        }
    }, [getThemeBy]);
    var updateTheme = function (colors) {
        setThemeObject(function (prevThemeObject) { return (__assign(__assign({}, prevThemeObject), { theme: __assign(__assign({}, prevThemeObject.theme), { primary: colors.primaryColor, secondary: colors.secondaryColor, text: __assign(__assign({}, prevThemeObject.theme.text), { primary: colors.textColor }), backgroundColor: colors.backgroundColor, logo: colors.logo }) })); });
        var newTheme = defaultTheme_1.defaultTheme;
        newTheme.primary = colors.primaryColor;
        newTheme.secondary = colors.secondaryColor;
        newTheme.text.primary = colors.textColor;
        newTheme.backgroundColor = colors.backgroundColor;
        newTheme.logo = colors.logo;
        newTheme.mobBackground.background = colors.backgroundColor.default;
        newTheme.mobBackground.backgroundLight = colors.backgroundColor.light;
        setMfwMobTheme(createMfwMobTheme_1.createMFWThemeMob(newTheme));
        setMfwWebMuiTheme(createMfwWebTheme_1.createMFWTheme(createMfwWebTheme_1.defaultSettings, newTheme));
    };
    return (react_1.default.createElement(exports.MfwThemeContext.Provider, { value: {
            theme: themeObject,
            mfwMuiWebTheme: mfwMuiWebTheme,
            mfwMobTheme: mfwMobTheme,
            setThemeName: setThemeName,
            isLoading: isLoading,
            updateTheme: updateTheme,
        } }, children));
};
exports.useMfwThemeProvider = function () {
    var context = react_1.useContext(exports.MfwThemeContext);
    if (!context) {
        throw new Error("useMfwThemeProvider must be used within a useMfwThemeProvider");
    }
    return context;
};
//# sourceMappingURL=MfwThemeProvider.js.map